export const TAB_BAR_HEIGHT = 77;
export const NAVBAR_HEADER_HEIGHT = 64;
